import React from "react";
import "./KiContent.scss";

const content = {
	"title": "Et nytt kapittel i juridisk søk \n– presisjon, veiledning og innsikt med KI.",
	"lead": "Når du stiller et spørsmål i Lovdatas nye KI-søk, får du langt mer enn bare treff på nøkkelord, du får hjelp til å forstå – og løse – det juridiske spørsmålet du faktisk lurer på.",
	"text": "Ved å kombinere det beste fra våre strukturerte juridiske kunnskapsdatabaser med kraften i moderne kunstig intelligens, tilbyr vi en ny måte å finne og forstå rettskilder på. Kjernen i løsningen er en teknologi som kombinerer dokumentbasert søk med avansert språkmodellering.",
	"steps": [
		{
			"title": "Spørsmålet ditt forbedres automatisk",
			"text": "Uansett hvordan du formulerer deg, tolker systemet spørsmålet ditt og oversetter det til et presist juridisk språk med rett terminologi og struktur. Eventuelle skrivefeil og forenklet språk håndteres sømløst."
		},
		{
			"title": "Relevante rettskilder hentes frem",
			"text": "Søket gjøres i Lovdatas omfattende dokumentbaser etter rettskilder som ikke bare inneholder lignende ord, men som faktisk handler om det samme temaet. Vi finner frem til lover, forskrifter, forarbeider, rettsavgjørelser, rundskriv, nemnder og mye mer. Du får en oversikt over de relevante rettskildene sammenstillingen bygges på slik at du kan ettergå, på samme måte som før."
		},
		{
			"title": "Kontekst og sammenheng analyseres",
			"text": "Systemet analyserer hvordan rettskilder henger sammen gjennom henvisninger, juridiske begreper og tematiske koblinger. Dette gir en dypere forståelse av konteksten og sørger for at søket treffer både bredt og presist."
		},
		{
			"title": "En stor språkmodell genererer svar",
			"text": "Det mest relevante materialet sendes videre til en språkmodell, som oppsummerer og forklarer rettskildene. Resultatet er en nyttig og informativ sammenstilling som hjelper deg å forstå hva rettskildene sier – og hva du bør gjøre videre."
		}
	]
}

export default function KiContent() {
	return (
		<div className="KiContent">
			<h2>{content.title}</h2>
			<p className="lead">{content.lead}</p>
			<p className="text">{content.text}</p>

			<div className="steps">
				<h3 className="steps-header">Slik fungerer det:</h3>
				<ul>
					{content.steps.map((step, index) => (
						<li key={index} className="step">
							<h4>
								<span className="step-number">
									<span>{index + 1}</span>
								</span>
								{step.title}
							</h4>
							<p>{step.text}</p>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
}